import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { createApi } from '@reduxjs/toolkit/query/react';
import { getAuthToken, removeAuthToken } from '../Localstorage/Localstorage';

export const customBaseQuery = (baseUrl) => async (args, api, extraOptions) => {
  const baseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      const token = getAuthToken();
      if (token) {
        headers.set('Authorization', `token ${token.api_key}:${token.api_secret}`);
      }
      return headers;
    },
  });

  const result = await baseQuery(args, api, extraOptions);
  if (result.error?.status === 401) {
    removeAuthToken();
    window.location.href = '/';
  }
  return result;
};

export const baseApi = createApi({
  reducerPath: 'api', 
  baseQuery: customBaseQuery(process.env.REACT_APP_API_URL),
  endpoints: () => ({}),
  tagTypes: ['Brand', 'Company']
});